import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CourseEnrollment } from '../../models/courseEnrollment';
import { Category } from '../../models/category';
import { Course } from '../../models/course';
import { CourseCardType } from '../../enums/courseCardType.enum';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AddToCartPopupComponent } from '../add-to-cart-popup/add-to-cart-popup.component';
import { Product } from '../../models/product';
import { Cart } from '../../models/cart';
import { CartService } from '../../services/cart/cart.service';
import { RouteEnum } from '../../enums/routes.enum';
import { AuthService } from '../../services/auth/auth.service';
import { CategoryCardAction } from '../../enums/categoryCardAction.enum';
import { ImageComponent } from '../image/image.component';
import { DynamicImageDirective } from '../../directives/dynamic-images/dynamic-image.directive';
import { IMAGES_RESOLUTIONS } from '../../utils/image-config';
import { VideoPlayerComponent } from '../video-player/video-player.component';

@Component({
  selector: 'app-store-card',
  standalone: true,
  imports: [CommonModule, MaterialModule, PipesModule, ImageComponent, DynamicImageDirective, VideoPlayerComponent],
  templateUrl: './store-card.component.html',
  styleUrl: './store-card.component.scss'
})
export class StoreCardComponent {

	cart:Cart = new Cart();
	cardTypes = CourseCardType;
	@Input() cardType!: CourseCardType;
	@Input() cardTypeOrientation!: CourseCardType;
	@Input() overviewCourse: boolean = false;
	@Input() courseEnrollment: CourseEnrollment;
	@Input() category: Category;
	@Input() course: Course;
	@Input() action : CategoryCardAction = CategoryCardAction.AVAILABLE;
	@Output() deleteFromCart = new EventEmitter<string>();
	@Output() addToCartEvent = new EventEmitter<string>();

	RouteEnum = RouteEnum;
	CategoryCardAction = CategoryCardAction;
	IMAGE_RESOLUTIONS = IMAGES_RESOLUTIONS;

	constructor(
		private dialog: MatDialog,
		private router: Router,
		private cartService: CartService,
		private authService: AuthService
	) { }

	overviewCategory(category: Category){
		this.router.navigate([`${this.getBasePath()}/${RouteEnum.CATEGORY_OVERVIEW}`], { queryParams: { categoryId: category.id } });
	}

	async addToCart(category: Category) {
		const product: Product = new Product({
			id: category.id,
			name: category.name,
			price: category.price,
			thumbnail: category?.image,
			createdBy: category?.createdBy
		});
		this.dialog.open(AddToCartPopupComponent, {
			width: '668px',
			height: 'auto',
			data: { category: category },
			disableClose: true,
		});
		await this.cartService.addToCart(product);
		this.action = category.__categoryCardAction = CategoryCardAction.IN_CART;
		this.addToCartEvent.emit(category.id);
	}

	removeFromCart(category: Category){
		this.cartService.removeFromCart(category.id);
		this.deleteFromCart.emit(category.id);
	}

	redirectToCart(){
		this.router.navigate([`${this.getBasePath()}/${RouteEnum.SHOPPING_CART}`]);
	}

	getBasePath() : string {
		const isLogged = this.authService.isUserLogged();
		return isLogged ? "" : RouteEnum.HOME;
	}

	redirectToCategoryView(){
		const firstCourseId = this.category.courses[0].id;
		this.router.navigate([`/${RouteEnum.MY_COURSES}/chapter-view/${this.category.id}/${firstCourseId}`]);
	}

	executeCategoryAction(action : CategoryCardAction){
		switch(action){
			case CategoryCardAction.IN_CART:
				this.redirectToCart();
				break;
			case CategoryCardAction.ENROLLED:
				this.redirectToCategoryView();
				break;
			case CategoryCardAction.AVAILABLE:
				this.addToCart(this.category);
				break;
			default:
				break;
		}
	}
}
